<script setup lang="ts">
import Tooltip from '@components/tooltip.vue';
import Icon from '@components/icons/icon.vue';
import type { IconColors } from '@components/icons/icon-types.js';
import { DisabledPropsInterface, useDisableComposable } from '@src/application/composables/disabled-composable.js';
import { TooltipProps } from '@components/tooltip-props.ts';
import { computed } from 'vue';

const { disabled } = useDisableComposable();

const props = defineProps<DisabledPropsInterface & TooltipProps & {
    icon: string|object,
    iconColor?: IconColors,
    hoverIconColor?: IconColors,
    class?: string|Array<string>,
}>();

const parentClass = computed(() => props.class);
defineOptions({
    inheritAttrs: false,
});
</script>

<template>
    <Tooltip
        :tooltip="tooltip"
        :position="position"
        :context="context"
        :color="color"
        :delay="delay"
        :expansion="expansion"
        :class="parentClass"
    >
        <Icon
            :icon="icon"
            :icon-color="!disabled ? iconColor : 'grey'"
            :hover-icon-color="disabled ? 'grey' : hoverIconColor ?? iconColor ?? 'primary'"
            :disabled="disabled"
            v-bind="$attrs"
        />
    </Tooltip>
</template>
